import React from "react";

const LoaderSmall = (props) => (
    <div className="w-100 text-center">
        <img style={{width: "230px"}} className="inline-block" src="/images/loader/loading.gif" alt="loading"/>
    </div>
)

export default LoaderSmall;